import DebugService from "@services/debug/Debug.service";
import ConfigsModelBuilder from "./builders/ConfigsModel.builder";
import ConfigsModel from "./models/Configs.model";

export default class ConfigsServiceBuilder {
    public static build(configsModel: ConfigsModel, debuger: DebugService): void {
        ConfigsModelBuilder.build(configsModel, debuger);
    }
}
